// footer dropdown

document.addEventListener("DOMContentLoaded", function () {

  const dropdownToggles = document.querySelectorAll(".footer-dropdown-toggle");

  dropdownToggles.forEach((toggle) => {
    toggle.addEventListener("click", function () {
      const menu = document.getElementById(this.getAttribute("aria-controls"));
      const button = this.querySelector(".dropdownFooterBtn svg use");
      const isExpanded = this.getAttribute("aria-expanded") === "true";
      
      dropdownToggles.forEach((otherToggle) => {
        const otherMenu = document.getElementById(otherToggle.getAttribute("aria-controls"));
        const otherButton = otherToggle.querySelector(".dropdownFooterBtn svg use");
        
        if (otherToggle !== this) {
          otherToggle.setAttribute("aria-expanded", "false");
          otherMenu.setAttribute("aria-hidden", "true");
          otherMenu.classList.remove("open");
          otherButton.setAttribute("xlink:href", "#icon-plus");
        }
      });
      
      this.setAttribute("aria-expanded", !isExpanded);
      menu.setAttribute("aria-hidden", isExpanded);
      menu.classList.toggle("open");
       if (!isExpanded) {
        button.setAttribute("xlink:href", "#icon-minus");
      } else {
        button.setAttribute("xlink:href", "#icon-plus");
      }
    });
  });
});